/**
 * AP-6 — CanFilterMaskWindow (FM-WIN-15), Titel "Filter Mask".
 * Prüfung: (id & mask) == (filterId & mask). Ungültige Hex-Eingabe ->
 * "Filter error: invalid mask/ID" (CanMonitorApp.cpp:2506, wörtlich).
 */

import { createButton, createInput, createLabel } from '../../ui/controls';
import { createFloatingPanel, type FloatingPanel } from './FloatingPanel';

export interface FilterMaskDialogOptions {
  onApply: (mask: number, maskId: number) => void;
  /** Hex-Parse-Fehler -> Status "Filter error: invalid mask/ID" (CanMonitorApp.cpp:2506). */
  onInvalid: () => void;
  onClear: () => void;
}

export interface FilterMaskDialogHandle {
  panel: FloatingPanel;
}

export function createFilterMaskDialog(options: FilterMaskDialogOptions): FilterMaskDialogHandle {
  const panel = createFloatingPanel('Filter Mask');

  const maskInput = createInput();
  maskInput.value = '1FFFFFFF';
  const idInput = createInput();
  idInput.value = '18FEF100';

  const maskRow = document.createElement('div');
  maskRow.className = 'cm-panel-window__row';
  maskRow.append(createLabel('Mask (hex):'), maskInput);

  const idRow = document.createElement('div');
  idRow.className = 'cm-panel-window__row';
  idRow.append(createLabel('ID (hex):'), idInput);

  const buttons = document.createElement('div');
  buttons.className = 'cm-panel-window__buttons';
  buttons.append(
    createButton('Apply Mask Filter', {
      accent: true,
      onClick: () => {
        const mask = parseHex(maskInput.value);
        const maskId = parseHex(idInput.value);
        if (mask === null || maskId === null) {
          options.onInvalid();
          return;
        }
        options.onApply(mask, maskId);
      },
    }),
    createButton('Clear Content Filter', { onClick: () => options.onClear() }),
  );

  panel.body.append(maskRow, idRow, buttons);
  return { panel };
}

/** `null` bei ungültiger Eingabe — Gegenstück zum std::stoul-Wurf im Original. */
function parseHex(text: string): number | null {
  const trimmed = text.trim();
  if (trimmed === '' || !/^[0-9a-fA-F]+$/.test(trimmed)) return null;
  const value = Number.parseInt(trimmed, 16);
  return Number.isFinite(value) ? value >>> 0 : null;
}
